import { Component } from '@angular/core';
import { UniTextComponent } from '../uni-text/uni-text.component';

@Component({
  selector: 'uni-text-body',
  templateUrl: './uni-text-body.component.html',
  styleUrls: ['./uni-text-body.component.scss'],
})
export class UniTextBodyComponent extends UniTextComponent {}
